import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackService } from 'src/app/services/snack.service';
import { ListItemCategoryDto } from '../../../services/api.services';
import { IItemSelectorCategory } from '../item-selector/reducer';
import { InsightsLibraryItem } from './types';

export interface SourceItem {
  name?: string;
  favourite?: boolean;
  categoryIds?: number[];
};

export function createItemsAndCategories<I extends InsightsLibraryItem, C extends IItemSelectorCategory<I>, S extends SourceItem>(
  itemCategories: ListItemCategoryDto[],
  sourceItems: S[],
  itemFactory: (itemSource: S) => any) {
  let items: I[] = [];
  let categories: C[] = [];

  let nextItemId = 1;
  let nextCategoryId = 1;

  let allCategory = <C>{
    id: nextCategoryId++,
    name: 'All',
    alwaysVisible: true,
    hidden: false
  };

  let uncategorizedCategory = <C>{
    id: nextCategoryId++,
    name: 'Uncategorized',
    alwaysVisible: false,
    hidden: false
  };

  if (sourceItems.length) {
    let itemCategoriesById = new Map<number, ListItemCategoryDto>(itemCategories.map(i => [i.id, i]));
    let categoryByName = new Map<string, C>();
    let itemAddedSet = new Set<string>();

    for (let itemSource of sourceItems) {
      let item = <I>{
        ...itemFactory(itemSource),

        id: nextItemId++,

        categoryIds: [],
        categories: [],

        hiddenByStarredOnly: false,

        highlightedName: null,
        hiddenByFilter: false,

        hidden: false,
      };

      items.push(item);

      item.categoryIds.push(allCategory.id);

      let addedToAnyItemCategory = false;

      for (let itemCategoryId of itemSource.categoryIds) {
        let itemCategory = itemCategoriesById.get(itemCategoryId);
        if (!itemCategory) {
          continue;
        }

        let itemKey = itemCategory.name + item.id;
        if (itemAddedSet.has(itemKey))
          continue;

        let category = categoryByName.get(itemCategory.name);
        if (!category) {
          if (itemCategory.name === 'All' || itemCategory.name === 'Uncategorized')
            continue;

          category = <C>{
            id: nextCategoryId++,
            name: itemCategory.name,
            alwaysVisible: false,
            hidden: false
          };

          categories.push(category);
          categoryByName.set(category.name, category);
        }

        item.categoryIds.push(category.id);
        item.categories.push(category.name);

        itemAddedSet.add(itemKey);

        addedToAnyItemCategory = true;
      }

      if (!addedToAnyItemCategory) {
        item.categoryIds.push(uncategorizedCategory.id);
        item.categories.push(uncategorizedCategory.name);
      }
    }

    categories.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  }

  categories = [allCategory, ...categories, uncategorizedCategory];

  items.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

  return { items, categories };
}

export function getSnackConfig(data: any, duration = 3000, panelClass = 'trg-snack-white'): MatSnackBarConfig {
  return {
    verticalPosition: 'top',
    panelClass: [panelClass],
    duration,
    data
  };
}
